import { TranslateService } from "@ngx-translate/core";

import { AuthState } from "state/auth.facade";

import { NavLinkConfig } from "./nav-header.interfaces";

export const CORITY_RESTRICTED_ROUTES = [
  "employees-list",
  "homepage",
  "compare",
  "upload",
];

export const CREATE_ROUTE = "upload";

export const getNavLinks = (translate: TranslateService): NavLinkConfig[] => [
  {
    route: "homepage",
    label: translate.instant("shared.navigation_bar.dashboard"),
    shouldBeDisplayed: ({ user }: AuthState) => !!user && !user.isLimited,
    supportsDevMode: true,
  },
  {
    route: "employees-list",
    label: (org, formatter) =>
      org
        ? translate.instant(formatter.orgFormat(org, true))
        : translate.instant("shared.navigation_bar.subjects"),
    supportsDevMode: true,
  },
  {
    route: "reports-list",
    label: translate.instant("shared.navigation_bar.assessments"),
    supportsDevMode: true,
  },
  {
    route: CREATE_ROUTE,
    label: translate.instant("shared.navigation_bar.upload"),
    supportsDevMode: true,
    shouldBeDisplayed: ({ user }: AuthState) => !!user && user.canEdit,
  },
  {
    route: "compare",
    label: translate.instant("shared.navigation_bar.comparison"),
    supportsDevMode: true,
  },
  { route: "learn", label: translate.instant("shared.navigation_bar.learn") },
  {
    route: "dev",
    label: translate.instant("shared.navigation_bar.dev"),
    shouldBeDisplayed: ({ user }: AuthState) => !!user?.hasDevPermissions,
  },
  {
    route: "admin",
    label: translate.instant("shared.navigation_bar.admin"),
    shouldBeDisplayed: ({ user }: AuthState) => !!user?.hasElevatedPermissions,
    supportsDevMode: true,
  },
];
